import { getAccountId, isExternal } from '@ally/transfer-account-utils';
import { validator } from '@ally/validator';
var NotBothExternalAccounts = function (_, _a) {
    var _b = _a.values, fromAccount = _b.fromAccount, toAccount = _b.toAccount, accounts = _a.accounts;
    if (!fromAccount || !toAccount)
        return true;
    var from = accounts.find(function (account) { return getAccountId(account) === fromAccount; });
    var to = accounts.find(function (account) { return getAccountId(account) === toAccount; });
    if (!from || !to)
        return true;
    return !(isExternal(from) && isExternal(to));
};
export var NotBothExternalAccountsErrorMessage = 'Both From and To accounts are external.';
export var NotBothExternalAccountsValidator = validator(NotBothExternalAccounts, NotBothExternalAccountsErrorMessage);
//# sourceMappingURL=NotBothExternalAccounts.js.map